import React, { useEffect, useState } from 'react'
import { SlEye } from 'react-icons/sl'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Select, Tag, Upload } from 'antd'
import eventImage from '../../../assets/gallery/event.png'
import { formatCurrency, handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit } from 'react-icons/bi'
import { LuFileUp } from 'react-icons/lu'
import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useGetSubscription, useGetSubscriptions, usePatchSubscription, usePostSubscription } from '../../../hooks/subscription/subscription'
import PaginationPage from '../../../components/paginationPage'
import SearchPage from '../../../components/searchPage'

function InsuranceSubTab() {
  const [createPayload, setCreatePayload] = useState({
    title:"",
    type:"",
    amount:0,
    percentageOff:0,
    description:"",
    numberOfDays:0
  })
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const onOpenEdit = () => setIsOpenEdit(true)
  const [page, setPage] = useState(0)
  const [search, setSearch] = useState('')

  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)
//   const onViewOpen = () => setIsViewOpen(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setIsOpenEdit(false)
    setRows([])
  }

  const uploadProps = {
    name: 'file',
    method: 'GET',
    multiple: true,
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
    },
  };
  
  const {
    data: getData,
    refetch: getFetch,
    isFetching: getLoad,
  } = useGetSubscriptions(
    { pageNumber:page, searchString: search, subscriptionType:"Insurance"},
    ["pageNumber", "searchString", "subscriptionType"],
  )

  const {
    data: getSingleData,
    mutate: getAction,
    isLoading: getSingleLoad,
  } = useGetSubscription(onOpenEdit)

  useEffect(() => {
    setCreatePayload({
      title: getSingleData?.data?.title || "",
      type: getSingleData?.data?.type || "",
      amount: getSingleData?.data?.amount || 0,
      percentageOff: getSingleData?.data?.percentageOff || 0,
      description: getSingleData?.data?.description || "",
      numberOfDays: getSingleData?.data?.numberOfDays || 0,
      id: getSingleData?.data?.id || "",
    })  
    
  }, [getSingleData?.data])

  const successAction = () => {
    getFetch()
    form.resetFields();
    onCreateClose()
  };

  const {
    mutate: postAction,
    isLoading: postLoad,
  } = usePostSubscription(successAction)

  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePatchSubscription(successAction)
  
  const handleEdit = (d) => {
    getAction(d.id)
  }

  const columns = [
    {
      title: "Subscription Name",
      dataIndex: "title",
      key:"1",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e}</p>
    },
    {
      title: "Type",
      dataIndex: "type",
      key:'2',
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key:'3',
      render: (e) => <p className='text-sm font-medium text-dim'>{formatCurrency(e)}</p>,
    },
    {
      title: "Percentage(%) Off",
      key:'4',
      dataIndex: "percentageOff",
      render: (e) => 
      <p className='text-sm font-medium text-dim'>{e} %</p>
    },
    {
      title: "Number of Days",
      dataIndex: "numberOfDays",
      key:'5'
    },
    {
      title: "Description",
      dataIndex: "description",
      key:'description'
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          // {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
          {key: "edit", label: <button className='flex' id='' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-4' /> Edit</button>},
          // {key: "delete", icon: <GoTrash className='!text-base' />, label: <button onClick={() => handleConfirm({})}>Delete</button>},
        ]}}
      >
        <Button className='!bg-[#F2F6FC]' loading={getSingleLoad} type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]

  const onSubmit = (d) => {
    postAction(d)
  }
  const onSubmitEdit = (d) => {
    putAction(createPayload)
  }

  return (
    <PadContainer loading={getLoad}>
      <TitleContainer
        path={false}
        title="Insurance Subscriptions"
        className="border border-lit rounded-xl"
        action={<div className='flex'>            
            <SearchPage setSearch={setSearch} size='' />
            <Button onClick={onCreateOpen} className='!bg-light_blue mx-2' type='primary' size='large' icon={<FaPlus />}>Add Subscriptions</Button>
        </div>
        }
      >
        <CustomTable
          pagination={false}
          column={columns}
          data={getData?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
        <PaginationPage 
          data={getData}
          setPage={setPage}
        />
      </TitleContainer>


      {/* create create drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Insurance Subscription</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Name" name="title">
            <Input size='large' placeholder='' />
          </Form.Item>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item label="Amount" name="amount" className=''>
              <Input size='large' className='!w-full' />
            </Form.Item>
            <Form.Item label="Percentage(%) Off" name="percentageOff" className=''>
              <Input size='large' className='!w-full' />
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item label="Type" name="type" initialValue="Insurance" className=''>
              <Input readOnly size='large' className='!w-full' />
              {/* <Select size='large' placeholder='Select Type'>
                <Select.Option value="Business">Business</Select.Option>
                <Select.Option value="Ads">Ads</Select.Option>
                <Select.Option value="Insurance">Insurance</Select.Option>
              </Select> */}
            </Form.Item>
            <Form.Item label="Number of Days" name="numberOfDays" className=''>
              <Input size='large' type='number' className='!w-full' />
            </Form.Item>
          </div>
          <Form.Item label="Description" name="description">
            <Input.TextArea placeholder='Enter description' size='large' rows={4} />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      {/* create edit drawer */}
      <Drawer
        open={isOpenEdit}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Insurance Subscription</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <Form.Item label="Name">
            <Input 
              size='large' 
              placeholder=''
              value={createPayload.title}
              onChange={({target:{value}})=> setCreatePayload({...createPayload, title: value})} 
            />
          </Form.Item>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item label="Amount" className=''>
              <Input 
                size='large' 
                className='!w-full' 
                value={createPayload.amount}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, amount: value})}
              />
            </Form.Item>
            <Form.Item label="Percentage(%) Off" className=''>
              <Input 
                size='large' 
                className='!w-full' 
                value={createPayload.percentageOff}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, percentageOff: value})}
              />
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item label="Type" className=''>
              <Input 
                size='large' 
                readOnly
                className='!w-full' 
                value={createPayload.type}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, type: value})}
              />
              {/* <Select 
                size='large' 
                placeholder='Select Type'    
                value={createPayload.type}
                onChange={(value)=> setCreatePayload({...createPayload, type: value})}
              >
                <Select.Option value="Business">Business</Select.Option>
                <Select.Option value="Ads">Ads</Select.Option>
                <Select.Option value="Insurance">Insurance</Select.Option>
              </Select> */}
            </Form.Item>
            {/* <Form.Item label="Type" className=''>
              <Input 
                size='large' 
                value={createPayload.type}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, type: value})}
                className='!w-full' 
              />
            </Form.Item> */}
            <Form.Item label="Number of Days" className=''>
              <Input 
                size='large' 
                type='number'                
                value={createPayload.numberOfDays}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, numberOfDays: value})}
                className='!w-full' 
              />
            </Form.Item>
          </div>
          <Form.Item label="Description">
            <Input.TextArea 
              placeholder='Enter description' 
              size='large' 
              value={createPayload.description}
              onChange={({target:{value}})=> setCreatePayload({...createPayload, description: value})}
              rows={4} 
            />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>View Insurance Subscription</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Subscription image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default InsuranceSubTab